module.exports = __webpack_public_path__ + "static/media/react-apollo-graphql.7e8fd0da.svg";